/**
 * Utilisé dans les formulaires pour ajouter/supprimer une image.
 */


function FileUpload()
{
    'use strict';

    var $divImgFileUpload = $('.img-file-upload');
    this.$input           = $('#fileupload');
    this.$blockImg        = $divImgFileUpload.find('.img-file-upload-img-block');
    this.$img             = this.$blockImg.find('img');

    /**
     * (Ré)Initialise à vide le plugin
     */
    this.empty = function() {
        this.$input.removeClass('d-none');
        this.$blockImg.addClass('d-none');
        this.$img.attr('src', '');
    }
}

$(function () {

    $(document).ready(function () {
        var $divImgFileUpload = $('.img-file-upload');
        var $input            = $('#fileupload');
        var $blockImg         = $divImgFileUpload.find('.img-file-upload-img-block');
        var $img              = $blockImg.find('img');
        var startSrc          = $divImgFileUpload.data('src');
        var src               = startSrc;

        function validFileType(file) {
            var fileTypes = [
                'image/gif',
                'image/jpeg',
                'image/pjpeg',
                'image/png',
                'image/svg'
            ];

            for (var i = 0; i < fileTypes.length; i++) {
                if (file.type === fileTypes[i]) {
                    return true;
                }
            }

            return false;
        }

        function verifyFileSize(file) {
            if (file.size > 8*1024*1024) {
                displayErrorMessage('La taille du fichier doit être inférieure à 8MO.');
                $input.val('');
                return false;
            }
            return true;
        }

        if (src) {
            $input.addClass('d-none');
            $img.attr('src', src);
            $blockImg.removeClass('d-none');
        } else {
            $input.removeClass('d-none');
            $blockImg.addClass('d-none');
        }

        // suppression du fichier
        $blockImg.find('a').click(function(e) {
            e.preventDefault();
            $input.removeClass('d-none');
            $blockImg.addClass('d-none');
            if (startSrc) {
                $('#fi-is-file-deleted').val(true);
            }
        });

        // ajout d'un fichier
        $input.on('change', function() {
            var curFiles = $input[0].files;
            if (curFiles.length === 0) {
                console.log('aucun fichier');
            } else {
                if (validFileType(curFiles[0]) && verifyFileSize(curFiles[0])) {
                    $img[0].src = window.URL.createObjectURL(curFiles[0]);
                    $input.addClass('d-none');
                    $blockImg.removeClass('d-none');
                }
            }
        });
    });
});
